import { PostHogProvider as WrappedPostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import type { ReactNode } from "react";
import { useEffect, useRef, useState } from "react";
import { useConsent } from "@/providers/consent-provider";

const token = import.meta.env.VITE_PUBLIC_POSTHOG_TOKEN;
const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

interface PostHogProviderProps {
  children: ReactNode;
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  const [initialized, setInitialized] = useState(false);
  const { analytics } = useConsent();
  const previousAnalytics = useRef<boolean | null>(null);

  useEffect(() => {
    if (!token || initialized) return;

    posthog.init(token, {
      api_host: host,
      ui_host: "https://eu.posthog.com",
      defaults: "2026-01-30",
      opt_out_capturing_by_default: true,
      cookieless_mode: "on_reject",
    });
    setInitialized(true);
  }, [initialized]);

  useEffect(() => {
    if (!initialized) return;
    if (previousAnalytics.current === analytics) return;
    previousAnalytics.current = analytics;

    if (analytics) {
      posthog.opt_in_capturing();
    } else {
      posthog.opt_out_capturing();
    }
  }, [initialized, analytics]);

  if (!token) return <>{children}</>;

  return <WrappedPostHogProvider client={posthog}>{children}</WrappedPostHogProvider>;
}
